<template>
  <div class="contact">
    <div class="contact-cycle">
      <span class="contact-cycle__title">给达人我的联系方式:</span><span @click="onOpenDialog">
        <span class="color-blue color-blue__underline" v-if="isSet">
          已设置
        </span>
        <span class="color-red color-red__underline" v-else>未设置</span>
      </span>
    </div>

    <el-dialog v-if="dialogVisible" width="850px" title="设置给达人的联系方式" :visible.sync="dialogVisible" modal-append-to-body
      append-to-body @cancel="onCancel">
      <div class="contact-msg color-pink">
        <div>
          1、请给您的达人提供有效的联系方式！！！让达人在有佣金等疑问的时候能联系上您！
        </div>
        <div>
          2、手机号或微信号必填一项。
        </div>
      </div>
      <el-form label-width="180px" :model="form" :rules="rules" ref="form">
        <div class="contact-flex">
          <el-form-item class="contact-left" label="给达人展示的我的名称" prop="showName">
            <div class="contact-flex">
              <el-input :disabled="disableName" v-model="form.showName" placeholder="请输入" :maxlength="50">
              </el-input>
            </div>
          </el-form-item>
          <div class="contact-tip">
            <span v-if="!disableName">名称每30天仅能修改1次。此处修改不会修改您的账户名。</span>
            <span v-else-if="nextModifyTimeStr">你近期已修改过名称，{{ nextModifyTimeStr }}后可再次修改</span>
          </div>

        </div>
        <div class="contact-flex">
          <el-form-item class="contact-left" label="手机号：" prop="showMobile">
            <div class="contact-flex">
              <el-input v-model="form.showMobile" placeholder="请输入手机号" :maxlength="11">
              </el-input>
            </div>
          </el-form-item>
        </div>
        <div class="contact-flex">
          <el-form-item class="contact-left" label="微信号：" prop="showVx">
            <div class="contact-flex">
              <el-input v-model="form.showVx" placeholder="请输入微信号" :maxlength="20">
              </el-input>
            </div>
          </el-form-item>
        </div>

      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>
import poi from "@/api/poi";
const PoiModel = new poi();
import { matchMobile } from "@/utils/regExp";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      disableName: false,// 是否禁止修改名称
      isSet: '',// 是否已设置 1:已设置 0:未设置
      nextModifyTimeStr: '',// 下一次修改名称的时间
      saveLoading: false,
      form: {
        showName: "",// 名称
        showMobile: "", // 手机号
        showVx: '',// 微信
      },
      dialogVisible: false, // 显示弹框
      rules: {
        showName: [{
          required: true, message: '请输入给达人展示的我的名称', trigger: ['blur', 'change']
        }],
        showMobile: [
          { pattern: matchMobile, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }
        ],
      },
    };
  },
  mounted() {
    this.getDetail()
  },
  computed: {
    ...mapGetters(["nickname"]),
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      this.getDetail()
      this.dialogVisible = true;
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 获取详情
    async getDetail() {
      const res = await PoiModel.queryGroupInfo()
      if (!res.data.success) {
        this.$message.error(res.data.message);
        return
      }
      this.isSet = !!res.data.data.showMobile || !!res.data.data.showVx
      this.$emit('getIsSetFun',this.isSet)
      this.nextModifyTimeStr = res.data.data.nextModifyTimeStr
      this.disableName = Boolean(res.data.data.disable)
      this.form = {
        showName: res.data.data.showName,
        showMobile: res.data.data.showMobile,
        showVx: res.data.data.showVx
      }
      // 如果没有默认读取账户名称
      if (!this.isSet && !this.form.showName) {
        this.form.showName = this.nickname
      }
    },
    // 确定
    async onSure() {
      await this.$refs.form.validate()
      this.saveLoading = true;
      if (!this.form.showMobile && !this.form.showVx) {
        this.$message.warning('手机号或微信号必填一项')
        this.saveLoading = false;
        return
      }
      const res = await PoiModel.saveGroupInfo({ ...this.form }).finally(() => {
        this.saveLoading = false;
      })

      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.onCancel()
      this.getDetail()
      this.$emit('refresh')
      this.$message.success(res.data.message);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form {
  .el-input {
    width: 213px;
  }
}

.contact {
  display: flex;
  align-items: center;
  margin-left: 20px;

  &-msg {

    padding: 8px;
    font-size: 12px;


    &>div {
      margin-bottom: 6px;
    }
  }


  &-cycle {

    &__title {
      margin-right: 10px;

    }
  }



  &-left {
    min-width: 350px;
    // margin-bottom: 0;

    &__day {
      margin-right: 10px;
    }

  }

  &-flex {
    display: flex;
  }

  &-tip {
    flex: 1;
    margin-left: 10px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    color: #999999;
    font-size: 12px;

    &__sub {
      color: #666;
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/contactInfo.vue